import {computed, effect, inject, Signal} from '@angular/core';
import {rxResource} from '@angular/core/rxjs-interop';

import {of} from 'rxjs';
import {signalStore, withComputed, withHooks, withMethods, withProps} from '@ngrx/signals';
import {withDevtools} from '@angular-architects/ngrx-toolkit';

import {AppConfigFacade} from '@selpia/app-config/data-access';
import {DimensionItem} from '@selpia/shared/models';

import {DimensionItemNode} from '../models';
import {DimensionItemConverter} from '../util/dimension-item-converter';
import {DimensionItemsService} from '../data-services/dimension-items.service';


function displayErrorEffect(
  errorSignal: Signal<unknown>,
) {
  effect(() => {
    const error = errorSignal();
    if (error) {
      console.error('DimensionItemsStore ERROR', error);
    }
  });
}

export const DimensionItemsStore = signalStore(
  {providedIn: 'root'},
  withDevtools('dimension-items'),
  withProps(() => ({
    _dimensionItemsService: inject(DimensionItemsService),
    _appConfigFacade: inject(AppConfigFacade),
  })),
  withProps((store) => ({
    _dimensionItemsResource: rxResource({
      request: () => store._appConfigFacade.dimensions(),
      loader: ({request}) => request?.length
        ? store._dimensionItemsService.loadAll(request)
        : of(undefined),
    }),
  })),
  withComputed((store) => ({
    dimensionItems: computed((): Map<string, DimensionItem[]> | undefined => store._dimensionItemsResource.value()),
    loading: computed(() => store._dimensionItemsResource.isLoading()),
  })),
  withComputed((store) => ({
    dimensionItemsTrees: computed((): Map<string, DimensionItemNode> | undefined => DimensionItemConverter.getDimensionItemsNodeMap(store.dimensionItems())),
  })),
  withComputed((store) => ({
    items_DEV: computed((): Record<string, DimensionItem[]> | undefined => PRODUCTION ? undefined : Object.fromEntries(store.dimensionItems() || [])),
    trees_DEV: computed((): Record<string, DimensionItemNode> | undefined => PRODUCTION ? undefined : Object.fromEntries(store.dimensionItemsTrees() || [])),
  })),
  withMethods((store) => ({
    load: () => {
      store._dimensionItemsResource.reload();
    },
  })),
  withHooks({
    onInit(store) {
      displayErrorEffect(store._dimensionItemsResource.error);
    },
  })
);
export type DimensionItemsStore = InstanceType<typeof DimensionItemsStore>;
